import {
  ExperienceDTO,
  SelectedSkillsDTO
} from '@staff-app/models/experienceDTO';
import {Action} from '@ngrx/store';

export enum ExperienceActionTypes {
  GetExperiences = '[Experience] Get Experiences',
  GetExperiencesSuccessful = '[Experience] Get Experiences Successful',
  SaveExperiences = '[Experience] Save User Experiences',
  SaveExperiencesSuccessful = '[Experience] Save User Experiences Successful',
  NavigateAway = '[Experience] Navigate Away'
}

export class GetExperiences implements Action {
  readonly type = ExperienceActionTypes.GetExperiences;

  constructor(public payload: number) {}
}
export class GetExperiencesSuccessful implements Action {
  readonly type = ExperienceActionTypes.GetExperiencesSuccessful;

  constructor(public payload: ExperienceDTO) {}
}

export class SaveExperiences implements Action {
  readonly type = ExperienceActionTypes.SaveExperiences;

  constructor(public payload: SelectedSkillsDTO, public isEditMode = false) {}
}

export class SaveExperiencesSuccessful implements Action {
  readonly type = ExperienceActionTypes.SaveExperiencesSuccessful;

  constructor() {}
}
export class NavigateAway implements Action {
  readonly type = ExperienceActionTypes.NavigateAway;

  constructor() {}
}
export type ExperienceActions =
  | GetExperiences
  | GetExperiencesSuccessful
  | SaveExperiences
  | SaveExperiencesSuccessful
  | NavigateAway;
